// Pre-blurred decorative blob, baked-once-via-SVG. A plain Tailwind
// `blur-3xl` on a colored div is re-rasterized on every paint; an SVG
// circle with `feGaussianBlur` applied is rasterized to a single bitmap
// the first time the layer composites and then just blits on subsequent
// paints. Same look, dramatically cheaper on the auth/loading screens.
//
// `color` accepts any CSS color (var(--…) included). `tintAlpha` keeps
// the soft 10%-ish look the originals had.

import { useRef } from 'react';

let uid = 0;
const makeId = () => `blob-blur-${++uid}`;

export default function StaticBlob({ color, tintAlpha = 0.4, className, style }) {
  // Stable filter id per instance — collisions would silently merge filters.
  const idRef = useRef(null);
  if (idRef.current === null) idRef.current = makeId();
  const id = idRef.current;

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      className={className}
      style={{ pointerEvents: 'none', ...style }}
    >
      <defs>
        <filter id={id} x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="20" />
        </filter>
      </defs>
      <circle cx="50" cy="50" r="36" fill={color} fillOpacity={tintAlpha} filter={`url(#${id})`} />
    </svg>
  );
}
